/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyConfiguration
 */
export interface AgencyConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AgencyConfiguration
     */
    readonly groups?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof AgencyConfiguration
     */
    brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
}

export function AgencyConfigurationFromJSON(json: any): AgencyConfiguration {
    return AgencyConfigurationFromJSONTyped(json, false);
}

export function AgencyConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groups': !exists(json, 'groups') ? undefined : (json['groups'] === null ? null : (json['groups'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
    };
}

export function AgencyConfigurationToJSON(value?: AgencyConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandsAndMarkets': value.brandsAndMarkets === undefined ? undefined : (value.brandsAndMarkets === null ? null : (value.brandsAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
    };
}


